<span
  class="date-toggle"
  [title]="getTitle()"
  role="button"
  tabindex="0"
  (click)="toggle()"
  (keyup.enter)="toggle()"
>
  {{ getContent() }}
</span>
